<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
      <CButton  color="info" @click="openModal"><b>Add New Member</b></CButton>

    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_edit_birthday="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @editbirthday="handleEditBirthday"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                            @grantwebaccess="handleGrantWebAccess"
                            @resetpassword="handleResetPassword"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <membermodal></membermodal>
    <membermodalbirthday></membermodalbirthday>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_member.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import member from '@/services/member';
import membermodal from './member_modal';

import membermodalbirthday from './member_modal_birthday';

import alertmodal from '@/views/alert/modal.vue';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: '',
  components: { Datatable, membermodal, alertmodal,membermodalbirthday },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false},
          {key: 'dob', sortable: false},
          {key: 'is_active', sortable: false},
          {key: 'web_access', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
   },
    created() {
      //this.loadData()
  },

   mounted (){
     this.loadData()
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

   beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('OPEN_MODAL_MEMBER')
    EventBus.$off('OPEN_MODAL_BIRTHDAY')
  },

  methods: {
    openModal: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
      var params = {title: 'Add New Member', mode:'create'}
      EventBus.$emit('OPEN_MODAL_MEMBER', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openShow: function(uuid){
      member.getMemberbyID(uuid)
      .then(res => {
      var params = {title: 'Detail member', mode:'detail', data:res.data}
      EventBus.$emit('OPEN_DETAIL_MEMBER', params)
      console.log('OPEN_DETAIL_MEMBER')
      })   
      let routeData = this.$router.resolve({path: '/member/member_detail',query: {Pud:uuid} }) 
      window.open(routeData.href, '_blank');
    },

    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Member', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_MEMBER', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    openModalEditBirthday(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Member', mode:'editbirthday', data:id}
        EventBus.$emit('OPEN_MODAL_BIRTHDAY', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    deactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Activate/deactivate member') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        member.deactivateMember(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
      }  
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Activate/deactivate member') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        member.reactivateMember(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
      }
    },

     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }
      member.getMemberDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleEditBirthday(val) {
        this.openModalEditBirthday(val) 
    }, 
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleGrantWebAccess(val) {
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Grant web access to member') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to grant web access?")){
        member.grantwebaccess(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
      }   
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    handleResetPassword(val) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf("Reset member's password") !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reset password?")){
        member.resetpassword(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
       
      }   
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END    
    },    

  }
  
}
</script>
